import request from '@/utils/request'

// 查询列表
export function apiInvGetRawMaterialDeliveryRateReport (query) {
  return request({
    url: '/inv/invCallRequestLines/rawMaterialDeliveryRateReport',
    method: 'get',
    params: query
  })
}

// 导出列表
export function apiInvCallRequestLinesNewExport (data) {
  return request({
    url: '/inv/invCallRequestLines/v2/exportRawMaterialReport',
    method: 'post',
    data: data
  })
}
